import { ConstraintConf } from '../../../../shopfloor/workcenters/capability/constraints/constraint-conf'
import { ConstraintSpec } from '../constraint-spec'

export class Configuration {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public spec: ConstraintSpec
  public conf: ConstraintConf

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.spec = new ConstraintSpec()

    this.conf = new ConstraintConf()
    this.conf.constraintSpecId = this.spec.id
  }
}
